import { NoContent } from '@visualfabriq/vf-ui-kit';

export function NoFilesToDisplay({ rootFolder }: { rootFolder: boolean }) {
  const message = rootFolder
    ? `Following designated folder(s) do not contain subfolder(s) matching the selected instance`
    : "You don't have any objects in this folder.";

  return <NoContent data-testid="NoFilesToDisplay" message={message} />;
}
